import { useQuery } from "@tanstack/react-query";
import { fetchPageComponents } from "../api/property-management";

export default function usePageComponents({
  page,
  trackTypeId,
}: {
  page?: string;
  trackTypeId?: number;
}) {
  return useQuery({
    queryKey: ["page-components", page, trackTypeId],
    queryFn: () =>
      fetchPageComponents({
        page,
        trackTypeId,
      }),
    staleTime: 1000 * 60 * 5, // 5 minutes
    cacheTime: 1000 * 60 * 10, // 10 minutes
    refetchOnWindowFocus: false,
    refetchOnReconnect: false,
    refetchOnMount: false,
    enabled: !!page && !!trackTypeId,
  });
}
